import { scrollToEl } from '../lib/lenis';

// Smooth in-page anchor scrolling, offset for the fixed nav.
export function initAnchors(): void {
  document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      if (!id || id === '#') return;
      const target = document.querySelector<HTMLElement>(id);
      if (!target) return;
      e.preventDefault();
      scrollToEl(target, -100);
    });
  });
}
